<template>
  <div class="service-form-view">
    <template v-if="option.group">
      <div
        v-for="(group, index) in option.group"
        :key="index"
        class="group-item"
        :style="group.style || {}"
      >
        <div class="group-title">
          {{group.label}}
        </div>
        <div class="group-content">
          <template v-if="group.column">
            <template v-for="(item, index) in group.column">
              <div
                v-if="item.display || item.display === undefined"
                :key="item.prop || index"
                class="form-item"
                :style="{...getItemStyle(item), ...item.itemStyle}"
              >
                <span
                  class="label"
                  v-if="item.label"
                  :class="{required: item.rules && item.rules.find(o=>o.required)}"
                  :style="item.labelStyle||{}"
                >{{item.label}}:</span>
                <span
                  class="input-box"
                  :class="{'is-error': !!errorObj[item.prop]}"
                  :style="item.boxStyle||{}"
                >
                  <template v-if="$slots[item.prop]">
                    <slot :name="item.prop" />
                  </template>
                  <template v-else>
                    <el-input
                      type="textarea"
                      v-if="item.type === 'textarea'"
                      :value="value[item.prop]"
                      @input="handleInput(item, $event)"
                      @blur="handleBlur(item, value[item.prop])"
                      :maxlength="item.maxlength || 500"
                      :rows="item.minRows || 2"
                      show-word-limit
                      :placeholder="item.placeholder"
                      :disabled="item.disabled"
                      clearable
                      @clear="handleBlur(item, '')"
                    />
                    <el-select
                      v-else-if="item.type === 'select'"
                      :value="value[item.prop]"
                      @change="handleInput(item, $event)"
                      :disabled="item.disabled"
                      :clearable="item.clearable"
                    >
                      <el-option
                        v-for="option in item.dicData"
                        :key="option[item.props ? item.props.value : 'value']"
                        :label="option[item.props ? item.props.label : 'label']"
                        :value="option[item.props ? item.props.value : 'value']"
                      />
                    </el-select>
                    <el-radio-group v-else-if="item.type === 'radio'" :value="value[item.prop]"
                        :disabled="item.disabled" @input="handleInput(item, $event)">
                          <el-radio v-for="radio in item.dicData" :key="radio[item.props ? item.props.value : 'value']" :label="radio[item.props ? item.props.value : 'value']">{{radio[item.props ? item.props.label : 'label']}}</el-radio>
                        </el-radio-group>
                    <avue-network
                      v-else-if="item.type === 'ser_network'"
                      v-model="value[item.prop]"
                      :selectDic="item.selectDic"
                      :props="item.props||{}"
                      :disabled="item.disabled"
                      :clearable="item.clearable"
                      :remoteQuery="item.remoteQuery"
                      :useCurNetworkInfo="item.useCurNetworkInfo"
                      :remoteUrl="item.dicUrl"
                      :remoteAllUrl="item.dicUrl"
                      :change="(res)=>networkInput(item, res)"
                    />
                    <!--  -->
                    <el-autocomplete
                      :value="value[item.prop]"
                      @input="handleInput(item, $event)"
                      @blur="handleBlur(item, value[item.prop])"
                      v-else-if="item.fetchSuggestions"
                      :fetch-suggestions="((queryString,cb)=>querySearch(queryString,cb,item))"
                      @select="handleSelect"
                      @focus="fetchInputFocus(item)"
                      :placeholder="item.placeholder"
                      :disabled="item.disabled"
                      :style="{width: item.valueWidth || '150px'}"
                      clearable
                      @clear="handleBlur(item, '')"
                      :maxlength="item.maxlength || 100"
                    />
                    <!--  -->

                    <el-input
                      :value="value[item.prop]"
                      @input="handleInput(item, $event)"
                      @blur="handleBlur(item, value[item.prop])"
                      v-else
                      :placeholder="item.placeholder"
                      :disabled="item.disabled"
                      :style="{width: item.valueWidth || '150px'}"
                      clearable
                      @clear="handleBlur(item, '')"
                      :maxlength="item.maxlength || 100"
                      @focus="handleFocus(item, value[item.prop])"
                    />
                  </template>
                  <div
                    class="success-label"
                    v-if="item.isSuccesslabel&&!errorObj[item.prop]"
                  >{{item.isSuccesslabel}}</div>
                  <div class="right-label" v-if="item.isRightLabel && !errorObj[item.prop]">{{item.isRightLabel}}</div>
                  <div class="error-label" v-if="item.isBottomLabel && !errorObj[item.prop]">{{item.isBottomLabel}}</div>
                  <div class="error-label">{{errorObj[item.prop]}}</div>
                </span>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template v-if="option.column">
      <template v-for="(item, index) in option.column">
        <div
          v-if="item.display || item.display === undefined"
          :key="item.prop || index"
          class="form-item"
          :style="{...getItemStyle(item), ...item.itemStyle}"
        >
          <span
            class="label"
            v-if="item.label"
            :class="{required: item.rules && item.rules.find(o=>o.required)}"
            :style="item.labelStyle||{}"
          >{{item.label}}:</span>
          <span
            class="input-box"
            :class="{'is-error': !!errorObj[item.prop]}"
            :style="item.boxStyle||{}"
          >
            <template v-if="$slots[item.prop]">
              <slot :name="item.prop" />
            </template>
            <template v-else>
              <el-input
                type="textarea"
                v-if="item.type === 'textarea'"
                :value="value[item.prop]"
                @input="handleInput(item, $event)"
                @blur="handleBlur(item, value[item.prop])"
                :maxlength="item.maxlength || 500"
                :rows="item.minRows || 2"
                show-word-limit
                :placeholder="item.placeholder"
                :disabled="item.disabled"
                clearable
                @clear="handleBlur(item, '')"
              />
              <el-select
                v-else-if="item.type === 'select'"
                :value="value[item.prop]"
                @change="handleInput(item, $event)"
                :disabled="item.disabled"
                :clearable="item.clearable"
              >
                <el-option
                  v-for="option in item.dicData"
                  :key="option[item.props ? item.props.value : 'value']"
                  :label="option[item.props ? item.props.label : 'label']"
                  :value="option[item.props ? item.props.value : 'value']"
                />
              </el-select>
              <!--  -->
              <el-autocomplete
                :value="value[item.prop]"
                @input="handleInput(item, $event)"
                @blur="handleBlur(item, value[item.prop])"
                v-else-if="item.fetchSuggestions"
                :fetch-suggestions="((queryString,cb)=>querySearch(queryString,cb,item))"
                @select="handleSelect"
                @focus="fetchInputFocus(item)"
                :placeholder="item.placeholder"
                :disabled="item.disabled"
                :style="{width: item.valueWidth || '150px'}"
                clearable
                @clear="handleBlur(item, '')"
                :maxlength="item.maxlength || 100"
              />
              <!--  -->
              <el-input
                :value="value[item.prop]"
                @input="handleInput(item, $event)"
                @blur="handleBlur(item, value[item.prop])"
                v-else
                :placeholder="item.placeholder"
                :disabled="item.disabled"
                :style="{width: item.valueWidth || '150px'}"
                clearable
                @clear="handleBlur(item, '')"
                :maxlength="item.maxlength || 100"
              />
            </template>
            <div class="error-label">{{errorObj[item.prop]}}</div>
          </span>
        </div>
      </template>
    </template>
    <div
      class="btn-view"
      v-if="!hidden"
    >
      <slot name="menuFormFront" />
      <el-button
        type="primary"
        :loading="loading"
        size="small"
        @click="handleSave"
      >保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      errorObj: {},
      // //
      historyDataList: {} // 历史记录列表
    }
  },
  props: {
    option: Object,
    loading: Boolean,
    value: Object,
    hidden: Boolean
  },
  //
  mounted() {
    console.log('`${item.prop}${this.user.name}`', this.user)
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    // 获取焦点
    fetchInputFocus(item) {
      const data = window.sessionStorage.getItem(`${item.prop}${this.user.staffNo}`)
      this.historyDataList[`${item.prop}${this.user.staffNo}`] = JSON.parse(data) ? JSON.parse(data).reverse() : JSON.parse(data)
      console.log('拿到下拉缓存的数据', data)
    },
    // waybillNoData
    querySearch(queryString, cb, item) {
      console.log(queryString, cb, item)
      var restaurants = this.historyDataList[`${item.prop}${this.user.staffNo}`] || []; // 准备的值
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      var results = restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // createFilter(queryString) {
    //   return (restaurant) => {
    //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    handleSelect(item) {
      console.log(item);
    },

    // /！---------------------！//////////
    getItemStyle(item) {
      const css = {}
      if (this.$slots[item.prop]) {
        css.height = 'auto'
      }
      if (item.span === 24) {
        css.width = '100%'
        css.display = 'flex'
        css.alignItems = 'start'
      }
      if (item.span === 16) {
        css.width = '300px'
      }
      if (item.flex) {
        css.display = 'flex'
      }
      if (item.type === 'textarea') {
        css.height = 'auto'
      }
      item.width && (css.width = item.width)
      item.height && (css.height = item.height)
      item.right && (css.paddingRight = item.right)
      item.bottom && (css.marginBottom = item.bottom)
      item.block && (css.float = 'none')
      return css
    },
    handleInput(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      this.$emit('input', data)
      if (typeof item.change === 'function') {
        item.change({
          valueObj: {},
          value: val
        })
      }
      // 判定是否触发change方法触发校验
      let fun = 'input'
      if (item.changeRules) {
        fun = 'change'
      }
      this.handleRule(item, val, fun)
    },
    handleBlur(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      if (typeof item.blur === 'function') {
        item.blur({
          valueObj: {},
          value: val
        })
      }
      this.handleRule(item, val, 'blur')
    },
    handleFocus(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      if (typeof item.focus === 'function') {
        item.focus({
          valueObj: {},
          value: val
        })
      }
      // this.handleRule(item, val, 'focus')
    },
    handleRule(item, val = '', type) {
      if (!item) {
        return
      }
      this.errorObj[item.prop] = ''
      if (item.rules && item.rules.length) {
        item.rules.map(rule => {
          if (rule && ~rule.trigger.indexOf(type)) {
            if (rule.validator && typeof rule.validator === 'function') {
              // 不确定回传rule 是什么 {}
              rule.validator({}, val, err => {
                if (err) {
                  this.errorObj = {
                    ...this.errorObj,
                    [item.prop]: err.toString().replace('Error: ', '')
                  }
                } else {
                  // 校验通过后添加到历史记录
                  // 先判断的是否是缓存历史记录的
                  if (item.fetchSuggestions) {
                    let historyData = window.sessionStorage.getItem(`${item.prop}${this.user.staffNo}`)
                    console.log('val', item, val, '前面')
                    // 判断的是否缓存过
                    !historyData ? historyData = [] : historyData = JSON.parse(historyData)
                    console.log('原有的历史记录', historyData)
                    if (historyData) {
                      let repeatData = false
                      // 重复不新增
                      historyData.find(o => { if (o.value === val) repeatData = true })
                      console.log('repeatDatarepeatDatarepeatData', repeatData)
                      if (!repeatData) {
                        console.log('val', item, repeatData, val)
                        if (historyData.length > 3) {
                          // 原来的已经存满了
                          historyData = historyData.slice(historyData.length - 2, historyData.length)
                        } else if (historyData.length === 3) {
                          historyData = historyData.slice(1)
                        }
                        historyData.push({ value: val, name: val })
                        window.sessionStorage.setItem(`${item.prop}${this.user.staffNo}`, JSON.stringify(historyData))
                        console.log(repeatData, '%s存储成功以后%s', window.sessionStorage.getItem(`${item.prop}${this.user.staffNo}`))
                      }
                    }
                  }
                }
              })
            }
            let required = ''
            if (val !== null && val.constructor === String) {
              required = !val.trim()
            } else {
              required = val === undefined || val === null
            }
            if (rule.required && required && (item.display || item.display === undefined)) {
              this.errorObj = {
                ...this.errorObj,
                [item.prop]: rule.message
              }
            }
          }
        })
      }
    },
    validate(cb) {
      if (this.option.group) {
        this.option.group.map(o => {
          o.column &&
            o.column.map(item => {
              this.handleRule(item, this.value[item.prop], 'blur')
            })
        })
      }
      this.option.column &&
        this.option.column.map(item => {
          this.handleRule(item, this.value[item.prop], 'blur')
        })
      cb && cb(!Object.values(this.errorObj).filter(o => o).length)
    },
    validateField(prop, cb) {
      let item
      if (this.option.group) {
        this.option.group.map(o => {
          if (o.column) {
            item = item || o.column.find(item => item.prop === prop)
          }
        })
      }
      if (this.option.column) {
        item = item || this.option.column.find(i => i.prop === prop)
      }
      setTimeout(() => {
        this.handleRule(item, this.value[prop] || '', 'blur')
      }, 10)
      console.log('validateField', item)
    },
    resetFields() {
      this.errorObj = {}
    },
    resetForm() {
      console.log('resetForm')
    },
    handleSave() {
      this.$emit('beforeSubmit')
      this.validate(val => {
        val && this.$emit('submit')
      })
    },
    clearValidate() {
      console.log('clearValidate')
    },
    networkInput(item, val) {
      if (typeof item.change === 'function') {
        item.change(val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.success-label {
  position: absolute;
  left: 10px;
  top: 22px;
  color: #4C4D57;
}
.service-form-view {
  .group-item {
    display: flex;
    margin-bottom: 20px;

    .group-title {
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #ddd;
      background-color: #fafafa;
      @include text-color('subtitle');
      @include border-color('lighter');
      @include bg-color('light');
      width: 20px;
      padding: 5px;
      text-align: center;
      font-weight: 600;
    }
    .group-content {
      flex: 1;
      margin-left: 10px;
      margin-bottom: -20px;
    }
  }
  .form-item {
    box-sizing: border-box;
    float: left;
    padding-right: 20px;
    margin-bottom: 20px;
    height: 24px;
    align-items: center;
    &.block-item {
      width: 100%;
    }
    &:after {
      content: '';
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .label {
      margin-right: 10px;
      white-space: nowrap;
      line-height: 24px;
      @include text-color('subtitle');
      float: left;
      &.required:before {
        content: '*';
        color: #f56c6c;
      }
    }
    .input-box {
      flex: 1;
      min-height: 24px;
      line-height: 24px;
      position: relative;
      display: inline-block;
    }
    .error-label {
      position: absolute;
      font-size: 12px;
      line-height: 16px;
      bottom: -16px;
      color: #f56c6c;
      white-space: nowrap;
    }
    .right-label{
      position: absolute;
      top: 5px;
      left: 160px;
    }
  }
  .btn-view {
    padding-top: 20px;
    padding-right: 20px;
    text-align: right;
  }
}
</style>
<style lang="scss">
.el-autocomplete-suggestion__list li {
  padding: 0 15px;
  line-height: 25px;
}
.service-form-view {
  .is-error {
    input,
    textarea {
      border: 1px solid #f56c6c;
    }
  }
  .el-radio__label {
    padding-left: 4px;
  }
  .cp-input .el-input {
    width: 200px;
  }
  .el-input {
    width: 150px;
    height: 24px;
    input {
      height: 24px;
      line-height: 24px;
      padding: 0 8px;
    }
    .el-input__icon {
      line-height: 24px;
    }
    .el-icon-circle-close {
      top: 6px;
    }
  }
  .el-textarea {
    textarea {
      resize: none;
      font-size: 12px;
      line-height: 16px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  .el-radio {
    margin-right: 10px !important;
  }
}
</style>

